import { Price } from '../interfaces/Price';

/**
 * Normalizes plan price strings like "€ 199.99 / month" to "€199.99/mo" for compact UI.
 * Returns null for custom/one-off prices that are not a monthly subscription.
 */
export function priceToPerMoShort(price: string): string | null {
  if (!price || price === 'Custom') return null;
  const trimmed = price.trim();
  if (/^€\s*0$/i.test(trimmed) || trimmed === '€ 0') {
    return '€0/mo';
  }
  if (!/\bmonth\b/i.test(price)) return null;
  const euro = price.match(/€\s*([\d.,]+)/);
  if (!euro) return null;
  return `€${euro[1].replace(',', '.')}/mo`;
}

function inferTier(plan: Price): Price['tier'] | undefined {
  return plan.tier;
}

/** i18n key for the short line under the plan title (who the plan is for). */
export function getPricingAudienceTranslationKey(plan: Price): string | null {
  const tier = inferTier(plan);
  if (!tier) return null;
  if (tier === 'free') return 'Pricing audience free';
  if (tier === 'enterprise') return 'Pricing audience enterprise';

  const pt = plan.planType;
  if (tier === 'starter') {
    if (pt === 'call') return 'Pricing audience starter call';
    if (pt === 'chat') return 'Pricing audience starter chat';
    if (pt === 'bundle') return 'Pricing audience starter bundle';
    return 'Pricing audience starter';
  }
  if (tier === 'business') {
    if (pt === 'call') return 'Pricing audience business call';
    if (pt === 'chat') return 'Pricing audience business chat';
    if (pt === 'bundle') return 'Pricing audience business bundle';
    return 'Pricing audience business';
  }
  return null;
}
